import React from 'react';
import Style from './Experience.module.scss';
import SectionHeader from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { info } from '../../info/Info';
import { ArrowUpRight } from '../ui/Icons';

export default function Experience({ innerRef }) {
    return (
        <section id="experience" ref={innerRef} className={Style.section}>
            <SectionHeader
                request="/experience"
                response={`200 OK · ${info.experience.length} spans`}
                title="Where I've shipped"
            />

            <div className={Style.list}>
                {info.experience.map((job, i) => {
                    const Row = job.link ? 'a' : 'div';
                    const rowProps = job.link
                        ? { href: job.link, target: '_blank', rel: 'noopener noreferrer' }
                        : {};
                    return (
                        <Reveal key={job.company} delay={i * 0.06}>
                            <Row className={Style.row} {...rowProps}>
                                <span className={Style.index}>{job.index}</span>
                                <div className={Style.main}>
                                    <div className={Style.head}>
                                        <h3 className={Style.company}>
                                            {job.company}
                                            {job.link && <ArrowUpRight size={16} />}
                                        </h3>
                                        {job.current
                                            ? <span className={Style.now}>● now</span>
                                            : <span className={Style.prev}>prev</span>}
                                    </div>
                                    <p className={Style.role}>
                                        {job.role} <span className={Style.period}>· {job.period}</span>
                                    </p>
                                    <p className={Style.summary}>{job.summary}</p>
                                    <div className={Style.stack}>
                                        {job.stack.map((s) => <span key={s}>{s}</span>)}
                                    </div>
                                </div>
                            </Row>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
